<template>
  <el-form-item
    v-show="it.isShow !== undefined ? it.isShow : true"
    v-bind="it.itemConfig"
    v-on="it.itemConfig&&it.itemConfig.events"
  >
    <span>{{ model[it.itemConfig.prop] || '--'}}</span>
    <template v-if="isJsxRender">
      <jsxTemplate :jsxRender="it.elConfig.jsxRender()"></jsxTemplate>
    </template>
  </el-form-item>
</template>

<script>
import jsxTemplate from '../FormItem/jsxTemplate.vue'

export default {
  name: 'TextItem',
  components: {
    jsxTemplate,
  },
  props: {
    it: {
      type: Object,
      default: () => {},
    },
    model: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isJsxRender() {
      const jsxRender = this.it?.elConfig?.jsxRender
      return !!jsxRender && typeof jsxRender === 'function'
    },
  },
  data() {
    return {}
  },
}
</script>

<style>

</style>
